/*
    Copyright 2022 Dynatrace LLC

    Licensed under the Apache License, Version 2.0 (the "License");
    you may not use this file except in compliance with the License.
    You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

    Unless required by applicable law or agreed to in writing, software
    distributed under the License is distributed on an "AS IS" BASIS,
    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
    See the License for the specific language governing permissions and
    limitations under the License.
*/

import type { Context } from "@azure/functions-v3";
import { SemConvTrace } from "@dynatrace/opentelemetry-core";

// ============================================================================

/**
 * Detect function trigger type.
 *
 * @note currently only HTTP trigger is supported
 *
 * @param context the azure function context
 * @param args the arguments passed to the function
 * @returns the trigger type
 */
export function getTriggerType(context: Context): SemConvTrace.FaasTriggerValues {
	if (Array.isArray(context.bindingDefinitions)) {
		for (const binding of context.bindingDefinitions) {
			if (binding.type === "httpTrigger") {
				return SemConvTrace.FaasTriggerValues.HTTP;
			}
		}
	}
	return SemConvTrace.FaasTriggerValues.OTHER;
}


// ----------------------------------------------------------------------------

/**
 * Returns the name of the HTTP out binding
 *
 * @param context the azure function context
 * @returns name of the out binding or undefined
 */
export function getHttpOutBindingName(context: Context): string | undefined {
	if (Array.isArray(context.bindingDefinitions)) {
		for (const binding of context.bindingDefinitions) {
			if (binding.type === "http" && binding.direction === "out") {
				return binding.name;
			}
		}
	}
	return undefined;
}
